const stats = [
  { value: "10+", label: "Years Experience" },
  { value: "600+", label: "Projects Completed" },
  { value: "500+", label: "Happy Clients" },
  { value: "24/7", label: "Support" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="relative py-16 md:py-28 border-y border-white/5 bg-[#070707] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 md:gap-y-12 gap-x-4 md:gap-x-6">
          {stats.map((s, i) => (
            <div key={s.label} data-testid={`stat-${i}`} className="flex flex-col gap-3 min-w-0">
              <div className="font-display text-4xl sm:text-5xl md:text-7xl font-semibold text-[#FF5A00] tracking-tight">
                {s.value}
              </div>
              <div className="h-px w-10 bg-white/20" />
              <div className="text-[10px] sm:text-[11px] uppercase tracking-[0.2em] sm:tracking-[0.25em] text-zinc-400">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
